import { Anchor, Box, Calendar, Carousel, Heading, Text } from 'grommet';
import { Link } from 'grommet-icons';
import React from 'react';
import PropTypes from 'prop-types';
import { Utils } from '@enrich/shared-lib';

export const ContactMeetings = ({ meetings = [] }) => {
    const currentDate = Date.now();
    const startOfDay = new Date(currentDate);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(currentDate);
    endOfDay.setHours(23, 59, 59, 999);
    const startOfDayISO = startOfDay.toISOString();
    const endOfDayISO = endOfDay.toISOString();

    const todaysMeetings = meetings.filter(
        (x) => x.meetingTime >= startOfDayISO && x.meetingTime <= endOfDayISO,
    );

    return (
        <Box
            direction="row-responsive"
            background="enrich-green-muted"
            elevation="large"
            pad="medium">
            <Box basis="large">
                <Heading level="3">Today&rsquo;s Meeting</Heading>
                {todaysMeetings.length > 0 ? (
                    <Carousel play={10000} fill={true}>
                        {todaysMeetings.map((x) => (
                            <div key={x.id}>
                                <MeetingDetails meeting={x} />
                            </div>
                        ))}
                    </Carousel>
                ) : (
                    <Box>
                        <Text
                            size="xlarge"
                            alignSelf="center"
                            color="enrich-light-grey">
                            No meeting
                        </Text>
                    </Box>
                )}
            </Box>
            <Box basis="small" margin={{ left: 'xlarge' }}>
                <Box direction="column">
                    <Heading level="3">Upcoming</Heading>
                    <Calendar
                        size="small"
                        color="red"
                        dates={meetings.map((x) => x.meetingTime)}
                        daysOfWeek={true}
                        showAdjacentDays={'trim'}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export const MeetingDetails = ({ meeting }) => {
    const displayTime = Utils.convertDateToDisplayDateString(
        new Date(meeting.meetingTime),
    );

    return (
        <Box
            background="enrich-green-light"
            round="6px"
            pad={{ top: 'medium', bottom: 'medium', horizontal: 'large' }}
            gap="20px">
            {meeting.contact && (
                <Text>
                    <b>Student: </b>
                    <Anchor
                        label={`${meeting.contact.firstName} ${meeting.contact.lastName}`}
                        href={`/contacts/${meeting.contact.id}`}
                    />{' '}
                </Text>
            )}
            <Text>
                <b>Reason: </b>
                {meeting.meetingReason}
            </Text>
            <Text size="30px" weight={500}>
                {displayTime}
            </Text>
            <Text>
                <Anchor
                    icon={<Link color="enrich-blue" />}
                    label="Click here to join"
                    href={meeting.joinUrl}
                    target="_blank"
                    color="enrich-blue"
                />
            </Text>
        </Box>
    );
};

ContactMeetings.propTypes = {
    headerTitle: PropTypes.string,
    meetings: PropTypes.array,
};

MeetingDetails.propTypes = {
    meeting: PropTypes.object,
};
